import { ImageList, LinearProgress, Stack } from "@mui/material";
import type { FC } from "react";
import TextSearch from "../textSearch/TextSearch";
import type { Image } from "./ImagePreview";
import ImagePreview from "./ImagePreview";

const ITEM_WIDTH = 296;
const ITEM_HEIGHT = 300;

interface Props {
  isLoading: boolean;
  images: Image[];
  selectedImages: Image[] | null;
  search: string;
  onSearchChange: (value: string) => void;
  onToggleImageSelection: (image: Image) => void;
  onDeleteImage?: (id: string) => void | Promise<void>;
  onEditImage?: (image: Image) => void | Promise<void>;
  onCropImage?: (image: Image) => void;
  onUpdatePrivacy?: (image: Image, isPrivate: boolean) => void | Promise<void>;
}

const ImagesPreview: FC<Props> = ({
  isLoading,
  images,
  selectedImages,
  search,
  onSearchChange,
  onToggleImageSelection,
  onDeleteImage,
  onEditImage,
  onCropImage,
  onUpdatePrivacy,
}) => {
  const selectedIds = new Set(selectedImages?.map((i) => i.id) ?? []);
  return (
    <Stack direction="column">
      <TextSearch fullWidth value={search} onChange={(text) => onSearchChange(text)} />
      {isLoading && <LinearProgress />}
      <ImageList
        sx={{ maxWidth: 1200, height: "100%", marginLeft: "auto", marginRight: "auto" }}
        cols={4}
        gap={4}
        rowHeight={ITEM_HEIGHT}
      >
        {images.map((item) => (
          <ImagePreview
            key={item.id}
            image={item}
            width={ITEM_WIDTH}
            height={ITEM_HEIGHT}
            selectMode={selectedImages !== null}
            selected={selectedIds.has(item.id)}
            onToggleSelection={() => onToggleImageSelection(item)}
            onDelete={onDeleteImage ? () => onDeleteImage(item.id) : undefined}
            onEdit={onEditImage ? () => onEditImage(item) : undefined}
            onCrop={onCropImage ? () => onCropImage(item) : undefined}
            onUpdatePrivacy={onUpdatePrivacy ? (isPrivate) => onUpdatePrivacy(item, isPrivate) : undefined}
          />
        ))}
      </ImageList>
    </Stack>
  );
};

export default ImagesPreview;
